<template>
  <div class="grid-string grid-string-header">
    <Cell class="cell-header cell-left cell-title text-sm">
      {{ $t('Local estimate title') }}
    </Cell>
    <Cell class="cell-header">
      {{ $t('Labour') }}
    </Cell>
    <Cell class="cell-header">
      {{ $t('Materials') }}
    </Cell>
    <Cell class="cell-header">
      {{ $t('Tools') }}
    </Cell>
    <Cell class="cell-header total-cell">
      {{ $t('Total') }}
    </Cell>
  </div>
</template>

<script>
  import Cell from '@/components/common/Cell';

  export default {
    name: 'SummaryTableHeader',
    components: { Cell },
  };
</script>
